export const getChangeImageBackgroundViewStyles = (_, { palette = {} } = {}) => ({
  '@global': {
    '@keyframes fetching_segments': {
      '0%': { backgroundPosition: '0%' }, // The whole background is 800% and we use only the 0-7 range
      '100%': { backgroundPosition: '100%' },
    },
  },
  dialogRoot: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 600,
    paddingTop: '16px !important',
    maxWidth: 1000,
    minHeight: 400,
    borderRadius: 8,
    boxShadow: '0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.10), 0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13);',
    padding: [16, 24, 24, 24],
  },
  dialogHeader: {
    display: 'flex',
    flexGrow: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dialogContent: {
    display: 'flex',
    flexGrow: 1,
    marginTop: 16,
    '& .background-change-view-container': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      '& .background-change-view-content-container': {
        flexGrow: 1,
        '& .objects-selection-view': {
          '& img': {
            width: '100%',
          },
          '& .description': {
            marginBottom: '16px',
            color: '#605E5C',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px',
          },
          '& .image-wrapper': {
            position: 'relative',
            width: 552,
            height: 382,
            '& img': {
              width: 552,
              height: 382,
              objectFit: 'contain',
            },
            '& div': {
              width: 552,
              height: 382,
            },
            '& .original-image': {
              borderRadius: '6px',
            },
            '& .cover-original-image': {
              background: 'linear-gradient(90deg, rgba(70, 79, 235, 0.75) 0%, rgba(180, 124, 248, 0.75) 100%)',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '6px',
            },
            '& .loading-segmentations-image': {
              background: 'linear-gradient(90deg, rgba(70, 79, 235, 0.75) 0%, rgba(180, 124, 248, 0.75) 100%)',
              animation: 'fetching_segments 3s linear infinite',
              position: 'absolute',
              backgroundSize: '400%',
              top: 0,
              left: 0,
              borderRadius: '6px',
            },
            '& .selected-image': {
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '6px',
            },
            '& .border-image': {
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '6px',
            },
            '& .highlighted-image': {
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '6px',
            },
          },
        },
      },
      '& .error-message': {
        marginTop: 16,
      },
      '& .background-change-view-actions-container': {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 0,
        alignItems: 'flex-end',
        height: 40,
        marginTop: 16,
        '& .left-control': {
          display: 'flex',
          flexGrow: 1,
          '& .start-over-button': {
            marginLeft: 4,
            '& i': {
              transform: 'rotateZ(90deg) rotateX(180deg)',
            },
          },
          '& .ms-Button-icon': {
            color: palette.neutralPrimary || '#323130',
          },
        },
      },
    },
  },

  dialogTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dialogTitleText: {
    color: palette.neutralPrimary,
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
    marginLeft: 6,
    marginRight: 6,
  },
  betaIndicator: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 6px',
    padding: '0 6px',
    height: 20,
    borderRadius: 4,
    border: '1px solid #E0E0E0',
    backgroundColor: '#F0F0F0',
    '& .beta-indicator-text': {
      color: '#616161',
      fontSize: 10,
      fontWeight: 600,
      lineHeight: '14px',
    },
  },
});

export const getBackgroundRemovalViewStyles = () => ({
  '@global': {
    '@keyframes loading_placeholder': {
      '0%': { backgroundPosition: '100%' },
      '50%': { backgroundPosition: '0%' },
      '100%': { backgroundPosition: '0%' },
    },
  },
  backgroundRemoveView: {
    '& .header': {
      color: '#605E5C',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22px',
      opacity: 0,
      maxHeight: 0,
      marginBottom: 0,
      transition: 'max-height 0.3s ease-out, opacity 0.3s ease-out, margin-bottom 0.3s ease-out',
      width: 552,
      '&.expanded': {
        marginBottom: '16px',
        maxHeight: '70px',
        opacity: 1,
      },
    },
    '&.expanded': {
      '& .image-container img': {
        backgroundImage: 'linear-gradient(45deg, #D7D9D8 25%, transparent 25%), linear-gradient(-45deg, #D7D9D8 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #D7D9D8 75%), linear-gradient(-45deg, transparent 75%, #D7D9D8 75%)',
        backgroundSize: '20px 20px',
        backgroundPosition: '0px 0px, 0px 10px, 10px -10px, -10px 0px',
      },
    },
    '& .image-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: 552,
      height: 382,
      borderRadius: 4,
      overflow: 'hidden',
      position: 'relative',
      '& img': {
        width: 552,
        height: 382,
        objectFit: 'contain',
      },
      '& .loading-mask': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        borderRadius: 6,
        opacity: 0.4,
        backgroundColor: '#E6E6E6',
        backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #47CFFA 50%, #B47CF8 100%)',
      },
    },
    '& .background-change-view-actions-container': {
      marginTop: 16,
      '& .remove-tip': {
        display: 'flex',
        alignItems: 'flex-start',
      },
      '& .action-box': {
        display: 'flex',
        alignItems: 'flex-end',
        opacity: 0,
        maxHeight: 0,
        transition: 'max-height 0.3s ease-out, opacity 0.3s ease-out',
        '&.expanded': {
          maxHeight: '40px',
          opacity: 1,
        },
        '& .goto-selection-view': {
          color: '#424242',
          fontSize: 14,
          fontStyle: 'normal',
          fontWeight: 600,
          border: 'none',
        },
        '& .right-action': {
          display: 'flex',
          marginLeft: 'auto',
          marginTop: 8,
          '& .goto-generation-view-button': {
            marginRight: 8,
            padding: '5px 12px',
            borderRadius: 4,
          },
          '& .cancel-button': {
            marginRight: 0,
            padding: '5px 12px',
            borderRadius: 4,
          },
        },
      },
    },
  },
});
